<ng-container *ngIf="facilities; else loading">
  <div
    class="overflow-auto pe-6 pe-xl-4"
    [style.height]="listHeight"
    #scrollContainer
  >
    <digital-platform-facility-item
      *ngFor="let location of facilities; let i = index"
      [location]="location"
      [i]="i"
      class="d-block mb-2"
      [id]="setFacilityId(location)"
    ></digital-platform-facility-item>
    <p
      *ngIf="facilities.length === 0"
      class="text-center my-15"
      data-automation-id="no-results-found-text"
    >
      No Results Found
    </p>
  </div>
</ng-container>
<ng-template #loading>
  <div class="spinner-border d-block margin-auto" role="status"></div>
</ng-template>
